import { render, staticRenderFns } from "./ReceiptWithdraw.vue?vue&type=template&id=1898444e&scoped=true"
import script from "./ReceiptWithdraw.vue?vue&type=script&lang=js"
export * from "./ReceiptWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1898444e",
  null
  
)

export default component.exports